import React, {useContext } from "react";
import { useNavigate } from "react-router-dom";
import { DeviceContext } from "../context/deviceContext";


export default function PropertyDescriptionProp(props) {
    const { mainClassName, textClassName, property } = props;

    const navigate = useNavigate();
    
    const {isMobile} = useContext(DeviceContext);

    // Handle cardClick
    const handleCardClick = ()=>{
        navigate(`/properties/property/${property._id}`);

    }
    
    return (
        <div className={mainClassName} onClick={handleCardClick}>
           <p className={textClassName}>
            {isMobile ? (property.description.length > 120
                ? property.description.slice(0, 120) + "..."
                : property.description
            ):(property.description)}
           </p>
        </div>
    );
}
